import styles from './OrderEngineStatus.module.css'
import ModalWindow from "../../../FormTemplate/ModalWindow/ModalWindow";
import MainFormTemplate from "../../../FormTemplate/MainFormTemplate/MainFormTemplate";
import React, {useEffect, useRef, useState} from "react";
import useApiQuery from "../../../ApiQuery/UseApiQuery";
import ErrorLineItem, {ErrorLineItemRef} from "../../../FormTemplate/ErrorLineItem/ErrorLineItem";
import ActiveRecordItem from "../../../FormTemplate/ActiveRecordItem/ActiveRecordItem";
import WaitLoader from "../../../WaitLoader/WaitLoader";
interface OrderEngineStatusPropsInt
{
    orderId: string
    onClose: ()=>void
}
interface OrderStatusInt
{
    orderId: string

}
export default function OrderEngineStatus({orderId, onClose                                          }:OrderEngineStatusPropsInt){
    const orderStatusRef = useRef<ErrorLineItemRef>(null)

    const [trackList, setTrackList] = useState<string[]>([])
    const [track, setTrack] = useState("")

    const orderStatusData = useRef<OrderStatusInt>({
        orderId: orderId
    })
    const [ldrOrderStatus,rsOrderStatus,exOrderStatus] = useApiQuery("/sell/sim/order/delivery/state","post",orderStatusData);

    useEffect(()=>{
        exOrderStatus().then((e)=>{
            if(e?.success)
            {
                if(e?.payload?.textList && Array.isArray(e?.payload?.textList ))
                {
                    setTrackList(e?.payload?.textList)
                }
                if(e?.payload?.track)setTrack(e?.payload?.track)
                return
            }
            if(orderStatusRef.current)orderStatusRef.current.show(e?.errorAsString ? e?.errorAsString :"Ошибка сервера",true,0)
        }).catch((e)=>{
            if(orderStatusRef.current)orderStatusRef.current.show(e?.errorAsString ? e?.errorAsString :"Ошибка сервера",true,3000)

        })
    },[orderStatusData])

    const buildTrackList = () =>{
        return trackList?.map((item,idx)=>{
            const text = `${idx+1} -  ${item}`
            return(
                <div key={idx} className={styles.trackItem}>{text}</div>
            )

        })
    }

    return(
        <ModalWindow onClose={()=>onClose()}>
            <div className={styles.mainCont}>
                <MainFormTemplate title={`Трэкинг доставки`} maxWidth={"500px"} background={"white"}>

                    <div className={"row w-100"}>
                        <div className={styles.titleCont}>
                            <div><span>заказ: </span>{orderId}<span> трэк: </span>{track}</div>
                        </div>
                    </div>
                    <div className={"row w-100"}>
                        <div className={styles.trackCont}>
                            {buildTrackList()}
                        </div>

                    </div>

                    <ErrorLineItem ref={orderStatusRef} ></ErrorLineItem>

                    <div className={styles.actCont}>
                        <div className={styles.btnCont}>
                            <button type="button" className="btn btn-secondary "
                                    onClick={(e)=>{
                                        onClose()
                                    }}
                            >Закрыть</button>
                        </div>
                        <WaitLoader loading={ldrOrderStatus  } api={rsOrderStatus} onlyLoading={true}>

                        </WaitLoader>
                    </div>

                </MainFormTemplate>
            </div>

        </ModalWindow>
    )



}